<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="true"
    ></bs-page-title>
    <div class="w100">
      <table class="table">
        <thead>
          <tr>
            <th class="w-75">ファイル</th>
            <th>DL</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="manual in manual_list" :key="manual.key">
            <td>{{ manual.label }}</td>
            <td>
              <a
                :href="
                  'https://api.mfj-members.jp/assets/manual/manage_2510/' +
                  manual.key +
                  '.pdf'
                "
                class="btn btn-sm btn-light btn-outline-secondary"
              >
                閲覧
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
// import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import config from '../../../const'

export default {
  name: 'ManageListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'マニュアル',
      fromParentBtn: '',
      manual_list: [
        { key: 1, label: '申請' },
        { key: 2, label: '会員情報' },
        { key: 3, label: 'お知らせ' },
        { key: 4, label: '競技会' },
        { key: 5, label: '決済' },
        { key: 9, label: 'エントリー管理' },
        { key: 6, label: '商品' },
        { key: 7, label: 'マスタ' },
        { key: 8, label: '管理者' }
      ]
    }
  },
  components: {
    BsPageTitle
    // BsButton,
    // BsMsgAlert
  },
  computed: {
    // ...mapState({
    //   // manage_account_level: state => state.apidata.manage_account_level
    // })
  },

  async created() {},
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'マニュアルです。'
  },

  methods: {}
}
</script>
